import * as headerBlock from '../header/index';

const alert = require('vue-strap').alert;
const spinner = require('vue-strap').spinner;

export default {
  name: 'working-areas',
  props: [
    'onLogout',
    'access_token',
    'authUser',
  ],
  components: { headerBlock, alert, spinner },
  mounted() {

  },
  data() {
    return {
      areas: {},
      areaActive: 0,
      globalArea: [],
      checkedAreas: [],
      newAreaName: '',
      newAreaLabel: '',
      newAreaPicture: '',
      addRemoveArea: {
        index: null,
        key: null,
      },
      areaModal: {
        index: null,
        key: null,
        name: '',
        label: '',
        picture: '',
        title: '',
      },
      breadCrumbItems: [
        {
          text: 'Home',
          to: `${process.env.START_URL}/`,
        }, {
          text: 'Working areas',
          active: true,
        },
      ],
      alertError: {
        text: 'Some fields are not filled',
        title: 'Error!',
        visible: false,
      },
      processLoading: false,
    };
  },
  methods: {
    setWorkHours(id, customShifts) {
      this.$router.push({ name: 'Days, times, shifts', params: { areaId: id, custom_shifts: customShifts } });
    },
    showModalDeleteArea($event, index, key) {
      this.areaModal.key = key;
      this.areaModal.index = index;
      this.$refs.modalDeleteArea.show();
    },
    showModalDeleteSubArea($event, index, key) {
      this.areaModal.key = key;
      this.areaModal.index = index;
      this.$refs.modalDeleteSubArea.show();
    },
    showModalAddArea($event, index, key = null) {
      this.addRemoveArea.key = key;
      this.addRemoveArea.index = index;
      this.$refs.modalAddArea[index].show();
    },
    showModalChangeAreaName($event, index, key) {
      this.areaModal.key = key;
      this.areaModal.index = index;
      this.areaModal.name = this.globalArea[index][key].name;
      this.$refs.modalChangeNameArea.show();
    },
    showModalChangeAreaLabel($event, index, key) {
      this.areaModal.key = key;
      this.areaModal.index = index;
      this.areaModal.label = this.globalArea[index][key].label;
      this.$refs.modalChangeLabelArea.show();
    },
    showModalChangeAreaPicture($event, index, key) {
      this.areaModal.key = key;
      this.areaModal.index = index;
      this.areaModal.picture = this.globalArea[index][key].picture;
      this.$refs.pictureFileInput.reset();
      this.$refs.modalChangeAreaPicture.show();
    },
    submitDeleteArea() {
      this.$http.patch(`areas/${this.globalArea[this.areaModal.index][this.areaModal.key].id}/`,
        { is_active: false },
        {
          method: 'PATCH',
          headers: {
            Authorization: `Token ${this.access_token}`,
          },
          // emulateJSON: true,
        })
        .then((response) => {
          if (response.status !== 200) {
            console.log(response);
            // that.$set(that, 'moduleError', true);
            return null;
          }
          this.getWorkingAreas();
          return response;
        })
        .catch((response) => {    
        
          if (response.status === 400) {
            console.log(`Area could not be deleted: ${response.body[0]}`);
            this.alertError.text = `Area could not be deleted: ${response.body[0]}`;
            this.alertError.visible = true;
            this.alertError.show();
          }
          
          if (response.status === 401) {
            this.onLogout();
          }
        });
      this.$refs.modalDeleteArea.hide();
    },
    submitDeleteSubArea() {
      console.log(this.areaModal.index);
      console.log(this.areaModal.key);
      console.log(this.globalArea[this.areaModal.index][this.areaModal.key]);
      for (let i = 0;
          i < this.globalArea[this.areaModal.index][this.areaModal.key].subareas.length;
          i++) {
        this.$http.patch(`areas/${this.globalArea[this.areaModal.index][this.areaModal.key].subareas[i].id}/`,
          { is_active: false },
          {
            method: 'PATCH',
            headers: {
              Authorization: `Token ${this.access_token}`,
            },
            // emulateJSON: true,
          })
          .then((response) => {
            if (response.status !== 200) {
              console.log(response);
              return null;
            }
            this.getWorkingAreas();
            return response;
          })
          .catch((response) => {
            if (response.status === 400) {
              console.log(`Area could not be deleted: ${response.body[0]}`);
              this.alertError.text = `Area could not be deleted: ${response.body[0]}`;
              this.alertError.visible = true;
              this.alertError.show();
            }
            
            if (response.status === 401) {
              this.onLogout();
            }
          });
      }
      this.$refs.modalDeleteSubArea.hide();
    },
    submitChangeAreaPicture() {
      if (!this.areaModal.picture) {
        return;
      }
      console.log('change picture area', this.areaModal.picture);
      this.changeWorkingAreaPicture({
        picture: this.areaModal.picture,
        id: this.globalArea[this.areaModal.index][this.areaModal.key].id });
      this.$refs.modalChangeAreaPicture.hide();
    },
    changeImageFile() {
      if (!this.areaModal.picture) {
        return null;
      }
      if (this.areaModal.picture &&
          this.areaModal.picture.size > 5000000) {
        this.$refs.pictureFileInput.reset();
        this.alertError.text = 'Maximum allowed file size is 5 MB.';
        this.alertError.visible = true;
      }
      return null;
    },
    changeWorkingAreaPicture(area) {
      const data = new FormData();
      data.append('picture', area.picture);
      this.$http.patch(`areas/${area.id}/`, data,
        {
          method: 'PATCH',
          headers: {
            Authorization: `Token ${this.access_token}`,
          },
          // emulateJSON: true,
        })
        .then((response) => {
          if (response.status !== 200) {
            console.log(response);
            // that.$set(that, 'moduleError', true);
            return null;
          }
          this.getWorkingAreas();
          return response;
        })
        .catch((response) => {
          if (response.status === 401) {
            this.onLogout();
          }
        });
    },
    submitChangeAreaLabel() {
      if (!this.areaModal.label) {
        // alert('Please enter your name');
        return;
      }
      console.log('change label area', this.areaModal.label);
      this.changeWorkingAreaLabel({
        label: this.areaModal.label,
        id: this.globalArea[this.areaModal.index][this.areaModal.key].id });
      this.$refs.modalChangeLabelArea.hide();
    },
    changeWorkingAreaLabel(area) {
      this.$http.patch(`areas/${area.id}/`, { label: area.label },
        {
          method: 'PATCH',
          headers: {
            Authorization: `Token ${this.access_token}`,
          },
          // emulateJSON: true,
        })
        .then((response) => {
          if (response.status !== 200) {
            console.log(response);
            // that.$set(that, 'moduleError', true);
            return null;
          }
          this.getWorkingAreas();
          return response;
        })
        .catch((response) => {
          if (response.status === 401) {
            this.onLogout();
          }
        });
    },
    submitChangeArea() {
      if (!this.areaModal.name) {
        // alert('Please enter your name');
        return;
      }
      console.log('change name area', this.areaModal.name);
      this.changeWorkingAreaName({
        name: this.areaModal.name,
        id: this.globalArea[this.areaModal.index][this.areaModal.key].id });
      this.$refs.modalChangeNameArea.hide();
    },
    changeWorkingAreaName(area) {
      this.$http.patch(`areas/${area.id}/`, { name: area.name, is_active: true },
        {
          method: 'PATCH',
          headers: {
            Authorization: `Token ${this.access_token}`,
          },
          // emulateJSON: true,
        })
        .then((response) => {
          if (response.status !== 200) {
            console.log(response);
            // that.$set(that, 'moduleError', true);
            return null;
          }
          this.getWorkingAreas();
          return response;
        })
        .catch((response) => {
          if (response.status === 401) {
            this.onLogout();
          }
        });
    },
    clearPicture() {
      this.areaModal.picture = '';
    },
    clearName() {
      this.newAreaName = '';
    },
    clearLabel() {
      this.newAreaLabel = '';
    },
    submitAddNewArea(e, index) {
      if (!this.newAreaName) {
        // alert('Please enter your name');
        return e.cancel();
      }
      console.log('added one area', this.newAreaName, index);
      let parent = index ? (this.globalArea[index - 1].activeId) : null;
      parent = (this.addRemoveArea.key === null) ?
              parent : this.globalArea[index][this.addRemoveArea.key].id;
      const data = {
        name: this.newAreaName,
        description: '',
        picture: null,
        parent,
        subareas: [],
      };
      if (this.$route.params.companyId) {
        data.company = this.$route.params.companyId;
      }
      console.log(this.globalArea[index]);
      this.newAreaName = '';
      // if (this.addRemoveArea.key !== null) {
      //   index++;
      //   this.globalArea.push([]);
      // }
      // this.globalArea[index].push(data);
      this.addRemoveArea.key = null;
      this.addWorkingArea(data);
      this.$refs.modalAddArea[index].hide();
      return null;
    },
    addWorkingArea(newArea) {
      this.$http.post('areas/', newArea,
        {
          method: 'POST',
          headers: {
            Authorization: `Token ${this.access_token}`,
          },
          // emulateJSON: true,
        })
        .then((response) => {
          if (response.status !== 201) {
            console.log(response);
            // that.$set(that, 'moduleError', true);
            return null;
          }
          this.getWorkingAreas();
          return response;
        })
        .catch((response) => {
          if (response.status === 401) {
            this.onLogout();
          }
        });
    },
    onClick($event, item, index) {
      this.globalArea = this.globalArea.slice(0, index + 1);
      this.checkedAreas = this.checkedAreas.slice(0, index);
      this.checkedAreas.push(item.id);
      if (!item.subareas.length) return;

      this.areaActive = item.subareas;
      item.subareas.activeId = false;
      this.globalArea.push(item.subareas);
      setTimeout(() => {
        const elem = document.getElementById('areas-wrapper');
        if (elem) {
          elem.scrollLeft = elem.scrollWidth;
        }
      }, 1);
    },
    // onLogout() {
    //   this.access_token = '';
    //   this.authUser = null;
    //   console.log(this.$route);
    //   // this.$route.router.go(process.env.START_URL + '/');
    // },
    getWorkingAreas() {
      let url = 'areas/?is_system=false';
      if (this.$route.params.companyId) {
        url = `${url}&company=${this.$route.params.companyId}`;
      }
      return this.$http.get(url,
        {
          method: 'GET',
          headers: {
            Authorization: `Token ${this.access_token}`,
          },
          // emulateJSON: true,
        })
        .then((response) => {
          if (response.status !== 200) {
            console.log(response);
            // that.$set(that, 'moduleError', true);
            return null;
          }
          response.body.activeId = false;
          this.globalArea = [];
          this.globalArea.push(response.body);
          for (let i = 0; i < this.checkedAreas.length && i < this.globalArea.length; i++) {
            for (let j = 0; j < this.globalArea[i].length; j++) {
              if (this.checkedAreas[i] === this.globalArea[i][j].id &&
                  this.globalArea[i][j].is_active) {
                this.globalArea[i].activeId = this.globalArea[i][j].id;
                if (!this.globalArea[i][j].subareas.length) return null;
                this.areaActive = this.globalArea[i][j].subareas;
                this.globalArea[i][j].subareas.activeId = false;
                this.globalArea.push(this.globalArea[i][j].subareas);
              }
            }
          }
          setTimeout(() => {
            const elem = document.getElementById('areas-wrapper');
            if (elem) elem.scrollLeft = elem.scrollWidth;
          }, 1);
          return response;
        })
        .catch((response) => {
          if (response.status === 401) {
            this.onLogout();
          }
        });
    },
    isHaveSubarea(area) {
      if (!area) {
        return false;
      }
      return area.filter(item => item.is_active).length;
    },
    dropdownShowen() {},
    getMarginTopArea(index) {
      let result = 0;
      for (let i = 1; i <= index; i++) {
        let emptyCount = 0;
        for (let j = 0; j < this.globalArea[i - 1].length; j++) {
          if (!this.globalArea[i - 1][j].is_active) {
            emptyCount++;
            continue;
          }
          if (this.globalArea[i - 1][j].id === this.checkedAreas[i - 1]) {
            result += 56 * (j - emptyCount);
            break;
          }
        }
      }
      return result;
    },
  },
  computed: {

  },
  created() {
    this.processLoading = true;
    this.getWorkingAreas()
    .then(() => {
      this.processLoading = false;
    })
    .catch(() => {
      this.processLoading = false;
    });
  },
};



// WEBPACK FOOTER //
// ./src/components/workingAreas/workingAreas.component.js